import type { FC } from "react"

import WarehouseFees from "./WarehouseFees"
import WarehouseInfo from "./WarehouseInfo"

const WarehouseInfoContainer: FC = () => {
  return (
    <div className='flex w-full flex-col gap-2.5'>
      <WarehouseInfo></WarehouseInfo>
      <WarehouseFees></WarehouseFees>
    </div>
  )
}

export default WarehouseInfoContainer
